export default () => {
    document.addEventListener("DOMContentLoaded", function () {
        const blockTextSlider = document.querySelectorAll(
            ".blockTextSlider__slider"
        );

        if (blockTextSlider) {
            blockTextSlider.forEach((singleSlider) => {
                const splideIcons = new window.splide(singleSlider, {
                    classes: {
                        pagination: 'splide__pagination splide__pagination--dark',
                    },
                    pagination: true,
                    arrows: false,
                    gap: "32px",
                    type: "loop",
                    perPage: 1,
                });

                splideIcons.mount();
            });
        }
    });
}